import { CWA_PUBLIC_URL, RAILS_PORT } from "config/globals";
import * as st from "lib/utils/socialtravel";
import BaseDecorator from "./BaseDecorator";

export default class CompanyDecorator extends BaseDecorator {
  static SOCIALTRAVEL_ID = 100;

  get is_st() {
    return this.id === this.constructor.SOCIALTRAVEL_ID;
  }

  get saas_url() {
    if (this.enable_saas) {
      return `${window.location.protocol}//${this.saas_host.split("old.").join("")}${
        RAILS_PORT ? `:${RAILS_PORT}` : ""
      }`;
    } else {
      return null;
    }
  }

  getMarketplaceHomepageUrl(params = {}) {
    if (this.enable_marketplace && (this.is_st || this.affiliate)) {
      return this.getMarketplaceWebsiteUrl(`/${I18n.locale}/`, params);
    } else if (this.enable_marketplace && this.supplier) {
      return this.getMarketplaceWebsiteUrl(`/${I18n.locale}/c/${this.id}-${this.saas_subdomain}`, params);
    } else {
      return null;
    }
  }

  getHomepageUrl(params = {}) {
    if (this.enable_saas) {
      return this.getSaasWebsiteUrl(`/${I18n.locale}`, params);
    } else if (this.enable_marketplace) {
      return this.getMarketplaceHomepageUrl(params);
    } else {
      return null;
    }
  }

  getSaasWebsiteUrl(path = "/", params = {}) {
    if (this.enable_saas) {
      return this.saas_url.split("old.").join("") + path + "?" + st.encodeURIParams(params);
    } else {
      return null;
    }
  }

  getMarketplaceWebsiteUrl(path = "/", params = {}) {
    if (this.enable_marketplace && this.affiliate) {
      return CWA_PUBLIC_URL.split("old.").join("") + path + "?" + st.encodeURIParams({ aid: this.id, ...params });
    } else if (this.enable_marketplace) {
      return CWA_PUBLIC_URL.split("old.").join("") + path + "?" + st.encodeURIParams(params);
    } else {
      return null;
    }
  }

  getWebsiteUrl(path = "/", params = {}) {
    if (this.enable_saas) {
      return this.getSaasWebsiteUrl(path, params);
    } else if (this.enable_marketplace) {
      return this.getMarketplaceWebsiteUrl(path, params);
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/CompanyDecorator.js